import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { MaterialPresupuestoItem } from './MaterialPresupuestoItem';

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
      backgroundColor: 'lightgray',
    },
  });

export const PracticaPresupuestoItem = (props) => {
    const { item } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();

    return ( 
        <>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row">
                    {item.practica?.desNom}
                </TableCell>
                <TableCell align="right">{item.cant}</TableCell>
                <TableCell align="center">{item.recuperoSur ? 'SI' : 'NO'}</TableCell>
                <TableCell>
                    {item.materiales.length > 0 &&
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    }
                </TableCell>
            </TableRow>
            <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 50 }} colSpan={3}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box margin={1}>
                  <Typography variant="h6" gutterBottom component="div">
                    Materiales
                  </Typography>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell>Material</TableCell>
                        <TableCell align="right">Cantidad</TableCell>
                        <TableCell align="center">SURGE</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                        {item.materiales.map((item) => (
                            <MaterialPresupuestoItem key={item?.material?.codigoNum?.toString()} item={item} />
                        ))}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
     );
}